/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import {
  Signer,
  BytesLike,
  BigNumberish,
  Contract,
  ContractFactory,
  Overrides,
} from 'ethers';
import { Provider, TransactionRequest } from '@ethersproject/providers';

import type { MerkleDistributor } from '../MerkleDistributor';

export class MerkleDistributor__factory extends ContractFactory {
  constructor(signer?: Signer) {
    super(_abi, _bytecode, signer);
  }

  deploy(
    token_: string,
    merkleRoot_: BytesLike,
    expireTimestamp_: BigNumberish,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<MerkleDistributor> {
    return super.deploy(
      token_,
      merkleRoot_,
      expireTimestamp_,
      overrides || {}
    ) as Promise<MerkleDistributor>;
  }
  getDeployTransaction(
    token_: string,
    merkleRoot_: BytesLike,
    expireTimestamp_: BigNumberish,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(
      token_,
      merkleRoot_,
      expireTimestamp_,
      overrides || {}
    );
  }
  attach(address: string): MerkleDistributor {
    return super.attach(address) as MerkleDistributor;
  }
  connect(signer: Signer): MerkleDistributor__factory {
    return super.connect(signer) as MerkleDistributor__factory;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): MerkleDistributor {
    return new Contract(address, _abi, signerOrProvider) as MerkleDistributor;
  }
}

const _abi = [
  {
    inputs: [
      {
        internalType: 'address',
        name: 'token_',
        type: 'address',
      },
      {
        internalType: 'bytes32',
        name: 'merkleRoot_',
        type: 'bytes32',
      },
      {
        internalType: 'uint256',
        name: 'expireTimestamp_',
        type: 'uint256',
      },
    ],
    stateMutability: 'nonpayable',
    type: 'constructor',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'uint256',
        name: 'claimIndex',
        type: 'uint256',
      },
      {
        indexed: true,
        internalType: 'address',
        name: 'account',
        type: 'address',
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'amount',
        type: 'uint256',
      },
    ],
    name: 'Claimed',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'address',
        name: 'previousOwner',
        type: 'address',
      },
      {
        indexed: true,
        internalType: 'address',
        name: 'newOwner',
        type: 'address',
      },
    ],
    name: 'OwnershipTransferred',
    type: 'event',
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: 'index',
        type: 'uint256',
      },
      {
        internalType: 'address',
        name: 'account',
        type: 'address',
      },
      {
        internalType: 'uint256',
        name: 'amount',
        type: 'uint256',
      },
      {
        internalType: 'bytes32[]',
        name: 'merkleProof',
        type: 'bytes32[]',
      },
    ],
    name: 'claim',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [],
    name: 'expireTimestamp',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: 'index',
        type: 'uint256',
      },
    ],
    name: 'isClaimed',
    outputs: [
      {
        internalType: 'bool',
        name: '',
        type: 'bool',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'merkleRoot',
    outputs: [
      {
        internalType: 'bytes32',
        name: '',
        type: 'bytes32',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'owner',
    outputs: [
      {
        internalType: 'address',
        name: '',
        type: 'address',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'renounceOwnership',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'target',
        type: 'address',
      },
    ],
    name: 'sweep',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [],
    name: 'token',
    outputs: [
      {
        internalType: 'address',
        name: '',
        type: 'address',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'newOwner',
        type: 'address',
      },
    ],
    name: 'transferOwnership',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
];

const _bytecode =
  '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';
